import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import Button from '@material-ui/core/Button';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';

import { withStyles } from '@material-ui/styles';
import { darken, lighten } from 'polished';
import { useSelector } from 'react-redux';
import { FormattedMessage, FormattedNumber } from 'react-intl';

const SummaryWrapper = styled.div`
  padding: 10px;
`;

const formattedNumberProps = {
  style: 'currency', currency: 'CZK',
};

const ColorButton = withStyles(() => {
  const color = '#fb8c00';
  const colorDisabled = '#aaaaaa';
  return {
    root: {
      fontSize: '1.5em',
      color: '#ffffff',
      background: `linear-gradient(60deg, ${lighten(0.15, color)}, ${color})`,
      '&:hover': {
        background: `linear-gradient(60deg, ${color}, ${darken(0.05, color)})`,
      },
      textTransform: 'none',
    },
    disabled: {
      background: `linear-gradient(60deg, ${lighten(0.15, colorDisabled)}, ${colorDisabled})`,
      '&:hover': {
        background: `linear-gradient(60deg, ${colorDisabled}, ${darken(0.05, colorDisabled)})`,
      },
    },
  };
})(Button);

const Summary = ({ openDialog }) => {
  const receiptLines = useSelector((state) => state?.receipt?.lines?.data);
  const [total, setTotal] = useState(0);
  const [disabled, setDisabled] = useState(true);


  useEffect(() => {
    const linesTotal = receiptLines?.reduce((accum, item) => {
      accum += parseFloat(item.data.amount);
      return accum;
    }, 0) || 0;
    setTotal(linesTotal);
    setDisabled(linesTotal === 0);
  }, [receiptLines]);

  return (
    <SummaryWrapper>
      <ColorButton variant='contained' endIcon={<ArrowForwardIosIcon />} size='large' fullWidth disabled={disabled}
                   onClick={openDialog}>
        <FormattedMessage id={'receipt.pay'} />
        &nbsp;
        <FormattedNumber value={total || 0} {...formattedNumberProps} />
      </ColorButton>
    </SummaryWrapper>
  );
};

export default Summary;
